<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "NUEVO" : "ACTUALIZAR" }} VISADO</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <!-- NOMBRE VISA -->
        <vs-input label="Nombre Visado" v-model="name_visa_type" class="mt-5 w-full" name="name_visa_type" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('name_visa_type')">{{ errors.first('name_visa_type') }}</span>

        <!-- ESTATUS VISADO -->
        <div class="vx-row mt-2">
          <div class="vx-col w-full">
            <label class="vs-input--label">Estatus visado</label>
            <v-select :closeOnSelect="true" v-model="flag_active_visa_type" :options="visado_status_options" label="label" :reduce="visado_status_options => visado_status_options.flag_active_visa_type"></v-select>
          </div>
        </div>
        
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Ingresar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      flag_active_visa_type: null,
      name_visa_type: null,
      visado_status_options: [
        {label:'Activo', flag_active_visa_type:1},
        {label:'Inactivo', flag_active_visa_type:0}
      ],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id_visa_type, name_visa_type, flag_active_visa_type } = JSON.parse(JSON.stringify(this.data))
        this.id_visa_type = id_visa_type
        this.name_visa_type = name_visa_type
        this.name_visa_type_original = name_visa_type
        this.flag_active_visa_type = flag_active_visa_type
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.name_visa_type && this.flag_active_visa_type !== null
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data.id_visa_type) return
      this.flag_active_visa_type = null
      this.name_visa_type = null
    },
    clearValues () {
      this.id_visa_type = null
      this.flag_active_visa_type = null
      this.name_visa_type = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.id_visa_type,
            name: this.name_visa_type,
            flag_active: this.flag_active_visa_type
          }
          if (this.name_visa_type === this.name_visa_type_original) delete obj.name
          this.$vs.loading()
          if (this.id_visa_type !== null && this.id_visa_type >= 0) {
            this.$store.dispatch('updateItemVisaType', obj)
              .then(() => { this.$emit('closeSidebarSuccess') })
              .then(() => { this.$vs.loading.close() })
              .then(() => {
                this.$vs.notify({
                  title: 'Visa actualizada',
                  text: 'Se actualizó un tipo de visado',
                  color: 'success',
                  iconPack: 'feather',
                  icon:'icon-check',
                  time: 5000
                }) 
              })
              .then(() => { this.clearValues() })
              .catch(err => { 
                this.$vs.loading.close()
                console.error(err)
                const mensaje_error = err.response.data.errors
                if (typeof mensaje_error === 'string') {
                  this.$vs.notify({
                    title: 'Error',
                    text: `${mensaje_error}`,
                    color: 'warning',
                    iconPack: 'feather',
                    icon:'icon-x-circle',
                    time: 6000
                  })
                } else {
                  const array_errors = Object.entries(mensaje_error)
                  for (let i = 0; i < array_errors.length; i++) {
                    this.$vs.notify({
                      title: 'Error',
                      text: `${array_errors[i][1][0]}`,
                      iconPack: 'feather',
                      icon: 'icon-x-circle',
                      color: 'warning',
                      time: 6000
                    })
                  }
                }
              })
          } else {
            delete obj.id
            this.$store.dispatch('addItemVisaType', obj)
              .then(() => { this.$emit('closeSidebarSuccess') })
              .then(() => { this.$vs.loading.close() })
              .then(() => {
                this.$vs.notify({
                  title: 'Visado creado',
                  text: 'Se ha creado un nuevo tipo de visado',
                  color: 'success',
                  iconPack: 'feather',
                  icon:'icon-check',
                  time: 5000
                }) 
              })
              .then(() => { this.clearValues() })
              .catch(err => { 
                this.$vs.loading.close()
                console.error(err)
                const mensaje_error = err.response.data.errors
                if (typeof mensaje_error === 'string') {
                  this.$vs.notify({
                    title: 'Error',
                    text: `${mensaje_error}`,
                    color: 'warning',
                    iconPack: 'feather',
                    icon:'icon-x-circle',
                    time: 6000
                  })
                } else {
                  const array_errors = Object.entries(mensaje_error)
                  for (let i = 0; i < array_errors.length; i++) {
                    this.$vs.notify({
                      title: 'Error',
                      text: `${array_errors[i][1][0]}`,
                      iconPack: 'feather',
                      icon: 'icon-x-circle',
                      color: 'warning',
                      time: 6000
                    })
                  }
                }
              })
          }

          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 550px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
